import { Box } from '@/components';
import { theme } from '@/components';
import type { WorkflowStageModel } from '@/features/workflow/models/workflow';
import { CheckOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import type { z } from 'zod';

type Props = {
  status: z.infer<typeof WorkflowStageModel>['status'];
};

export const StageStatusSignifier: FC<Props> = ({ status }) => {
  const { token } = theme.useToken();
  const circleBaseStyles = {
    width: 16,
    height: 16,
    border: `4px solid ${token.colorTextTertiary}`,
    borderRadius: '50%',
  } as const;

  switch (status) {
    case 'pending':
      return (
        <Box {...circleBaseStyles} borderColor={token.colorTextTertiary} />
      );
    case 'reviewing':
      return <Box {...circleBaseStyles} borderColor={token.blue7} />;
    case 'approved':
      return (
        <Box
          {...circleBaseStyles}
          border="none"
          backgroundColor={token.colorSuccess}
        >
          <CheckOutlined
            style={{ width: 8, height: 8, color: token.colorWhite }}
          />
        </Box>
      );
    case 'rejected':
      return <Box {...circleBaseStyles} borderColor={token.colorError} />;
    default:
      return null;
  }
};
